import { render, staticRenderFns } from "./PropertyRentalData.vue?vue&type=template&id=52cc849f&scoped=true&"
import script from "./PropertyRentalData.vue?vue&type=script&lang=js&"
export * from "./PropertyRentalData.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRentalData.vue?vue&type=style&index=0&id=52cc849f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc849f",
  null
  
)

export default component.exports